import React from "react";

export default function StarRating({
  value = 0,
  onChange,
  size = 28,
  readOnly = false,
  strokeColor = "#3390B3",
  strokeWidth = 1,
}) {
  const v = Number(value) || 0;

  return (
    <div
      style={{
        display: "inline-flex",
        gap: 6,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= v;

        return (
          <button
            key={i}
            type="button"
            onClick={() => !readOnly && onChange?.(i)}
            aria-label={`${i} stelle`}
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: readOnly ? "default" : "pointer",
              fontSize: size,
              lineHeight: 1,

              // ⭐ colore stella
              color: filled ? "#FFD24D" : "rgba(51,144,179,0.35)",

              // ✅ bordo blu: risolve il problema giallo su giallo
              WebkitTextStroke: `${strokeWidth}px ${strokeColor}`,

              // ✅ fallback universale + maggiore contrasto
              textShadow: filled
                ? `
                  1px 0 ${strokeColor},
                  -1px 0 ${strokeColor},
                  0 1px ${strokeColor},
                  0 -1px ${strokeColor}
                `
                : "none",
            }}
          >
            ★
          </button>
        );
      })}
    </div>
  );
}
